import movementTypes from 'modules/transactions/constants/movementTypes';
import transactionTypes from 'constants/transactionTypes';
import { createMovement } from 'modules/transactions/utils/createMovement';
import { createTransaction } from 'modules/transactions/utils/createTransaction';

import { HistoryMovement, Movement, Range, Transaction } from 'types';

import { BaseDataForCapitalIncrease } from '../constants/baseDataForCapitalIncrease';

type BuildMockDataResult = {
  movements: Movement[];
  historyMovements: HistoryMovement[];
  transactions: Transaction[];
  totalSharesToAdd: number;
};

export const buildMockDataFromBaseData = (
  baseData: BaseDataForCapitalIncrease
): BuildMockDataResult => {
  const movements: Movement[] = [];
  const historyMovements: HistoryMovement[] = [];
  const transactions: Transaction[] = [];
  let totalSharesToAdd = 0;

  baseData.partners.forEach((partner) => {
    const { partnerId, partnerName, rangeFrom, rangeTo, sharePremium = 0 } =
      partner;

    const sharesCount = rangeTo - rangeFrom + 1;
    if (sharesCount <= 0) return;

    totalSharesToAdd += sharesCount;

    const range: Range = {
      from: rangeFrom,
      to: rangeTo,
      partner: partnerId,
      shareClass: baseData.shareClassId,
      sharePremium,
    };

    const incrementMovement = createMovement({
      range,
      movementType: movementTypes.INCREMENT,
    });
    movements.push(incrementMovement);

    historyMovements.push({
      from: rangeFrom,
      to: rangeTo,
      holdingClassName: baseData.holdingClassName,
      partnerNameSeller: partnerName,
    });

    const transaction = createTransaction({
      range: {
        ...range,
        sharePremium,
      },
      transactionType: transactionTypes.CAPITAL_INCREASE,
    });
    transactions.push(transaction);
  });

  return {
    movements,
    historyMovements,
    transactions,
    totalSharesToAdd,
  };
};
